import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import TabelaLoading from '../../components/TabelaLoading';
import TabelaVazia from '../../components/TabelaVazia';
import { FaCheckCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { data as dataUtil } from '../../util/util';

export default function LiberarStartRsvp() {
    const PAGE_SIZE_DEFAULT = 20;
    const token = localStorage.getItem('token');
    const [eventos, setEventos] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [liberandoId, setLiberandoId] = useState(null);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        total: 0,
    });
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const buscar = ({ page = pagination.page, pageSize = pagination.pageSize, resetPage = false } = {}) => {
        if (resetPage) {
            setResetPaginationToggle((valorAtual) => !valorAtual);
        }

        setCarregando(true);
        api({
            method: 'get',
            action: '/evento',
            token: token,
            params: {
                rsvp: 'sim',
                startrsvpbackoffice: 'nao',
                situacao: ['ativo', 'pendente'],
                page,
                pageSize,
            },
        })
            .then((response) => {
                const lista = response.data.data || [];
                setEventos(lista);
                setPagination({
                    page: response.data.page ?? page,
                    pageSize: response.data.pageSize ?? pageSize,
                    total: response.data.total ?? lista.length,
                });
            })
            .catch(() => {
                toast.error('Erro ao carregar eventos');
                setEventos([]);
                setPagination((valorAtual) => ({
                    ...valorAtual,
                    total: 0,
                }));
            })
            .finally(() => setCarregando(false));
    };

    useEffect(() => {
        buscar({ page: 1, resetPage: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const liberar = (evento) => {
        setLiberandoId(evento.id);
        api({
            method: 'post',
            action: '/evento/liberarStartRsvp/' + evento.id,
            token: token,
        })
            .then(() => {
                toast.success(evento.nome ? `Start RSVP liberado: ${evento.nome}` : 'Start RSVP liberado com sucesso.');
                buscar();
            })
            .catch((err) => {
                const msg = err.response?.data?.mensagem || err.response?.data?.error || 'Erro ao liberar Start RSVP';
                toast.error(msg);
            })
            .finally(() => setLiberandoId(null));
    };

    const columns = [
        { name: 'Código', selector: (row) => row.codigo ?? '-', sortable: true, width: '100px' },
        { name: 'Nome', selector: (row) => row.nome ?? '-', sortable: true, wrap: true },
        {
            name: 'Cliente',
            selector: (row) => {
                const c = row.Cliente || row.cliente;
                if (!c) return '-';
                if (typeof c === 'object') {
                    const nf = (c.nomefantasia || '').trim();
                    const nome = (c.nome || '').trim();
                    if (nf && nome && nf !== nome) return `${nf} (${nome})`;
                    return nf || nome || '-';
                }
                return c;
            },
            sortable: false,
            wrap: true,
        },
        {
            name: 'Data',
            selector: (row) => (row.data ? dataUtil(row.data) : '-'),
            sortable: true,
            width: '100px',
        },
        {
            name: 'Ações',
            cell: (row) => (
                <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={() => liberar(row)}
                    disabled={liberandoId === row.id}
                >
                    {liberandoId === row.id ? (
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                    ) : (
                        <FaCheckCircle className="me-1" />
                    )}
                    Liberar
                </button>
            ),
            width: '120px',
            ignoreRowClick: true,
        },
    ];

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <h1 className="mb-4">Liberar Start RSVP</h1>
                <p className="text-muted mb-4">
                    Eventos com RSVP ativo e ainda não liberados pelo Backoffice. Ao clicar em Liberar, o sistema registra a liberação e envia o e-mail de Start RSVP para os destinatários configurados.
                </p>
                
                    <div className="table-responsive">
                    <DataTable
                        columns={columns}
                        data={eventos}
                        progressPending={carregando}
                        persistTableHead
                        progressComponent={<TabelaLoading texto="Carregando eventos..." />}
                        pagination
                        paginationServer
                        paginationTotalRows={pagination.total}
                        paginationPerPage={pagination.pageSize}
                        paginationDefaultPage={pagination.page}
                        paginationResetDefaultPage={resetPaginationToggle}
                        paginationRowsPerPageOptions={[10, 20, 50, 100]}
                        onChangePage={(novaPagina) => buscar({ page: novaPagina })}
                        onChangeRowsPerPage={(novoPageSize) => buscar({ page: 1, pageSize: novoPageSize, resetPage: true })}
                        noDataComponent={<TabelaVazia texto="Nenhum evento pendente de liberação de Start RSVP." />}
                        dense
                    />
                    </div>
            </div>
        </ErpTemplate>
    );
}
